<template>
  <section>
    <b-row>
      <b-col lg="8" cols="12" class="d-flex flex-column order-lg-0 order-1">
        <cheers-card class="w-100" />
        <b-row class="flex-wrap px-50">
          <b-col
            cols="6"
            class="d-flex px-50"
            v-for="(card, index) in cards"
            :key="index"
          >
            <statistic-card-horizontal
              class="w-100"
              :info="card"
              :loading="loading"
              :dashboard="dashboard"
            />
          </b-col>
        </b-row>
      </b-col>
      <b-col lg="4" cols="12" class="d-flex order-lg-1 order-0">
        <user-info-card
          class="w-100"
          @showChangeAccountModal="showChangeAccountModal"
          :loadingDashboard="loading"
          :dashboard="dashboard"
        />
      </b-col>
    </b-row>
    <b-row class="flex-column-reverse flex-md-row">
      <b-col lg="8" cols="12" class="d-flex">
        <my-trading-accounts :loading="loading" :accounts="accounts" class="w-100" />
      </b-col>
      <b-col lg="4" cols="12" class="d-flex">
        <most-traded-symbols
          :loading="loading"
          :dashboard="dashboard"
          class="w-100"
        />
      </b-col>
    </b-row>
  </section>
</template>

<script>
import { BRow, BCol } from "bootstrap-vue";
import UserInfoCard from "./UserInfoCard.vue";
import StatisticCardHorizontal from "./StatisticCardHorizontal.vue";
import CheersCard from "./CheersCard.vue";
import MostTradedSymbols from "./MostTradedSymbols.vue";
import MyTradingAccounts from "./MyTradingAccounts.vue";
// import ChangeAccountModal from "./change-account-modal/ChangeAccountModal.vue";
export default {
  components: {
    BRow,
    BCol,
    UserInfoCard,
    StatisticCardHorizontal,
    CheersCard,
    MostTradedSymbols,
    MyTradingAccounts,
    // ChangeAccountModal,
  },
  data() {
    return {
      visible: false,
      needChangeAccount: [],
      accounts: {},
      cards: [
        {
          img: "balance.png",
          description: "My balance",
          key: "balance",
          class: "bg-balance",
          color: "#1BC1BA",
        },
        {
          img: "trades-won.png",
          description: "Total trades won",
          key: "total_trade_wins",
          class: "bg-total-won",
          color: "#FBAD25",
        },
        {
          img: "trades-lost.png",
          description: "Total trades lost",
          key: "total_trade_lost",
          class: "bg-total-lost",
          color: "#D3435D",
        },
        {
          img: "competitions.png",
          description: "My competitions",
          key: "count_competitions",
          class: "bg-competitions-count",
          color: "#39A4F8",
        },
        // {
        //   img: "user.png",
        //   description: "User",
        //   key: "count_competitions",
        //   class: "bg-user",
        //   color: "#4B62FA",
        // },
        // {
        //   img: "tickets.png",
        //   description: "Support tickets",
        //   key: "tickets",
        //   class: "bg-tickets",
        //   color: "#25ECFB",
        // },
      ],
      dashboard: {},
      loading: false,
    };
  },
  async created() {
    this.loading = true;
    await this.getDashboard();
    await this.getCharts()
    this.loading = false;
  },
  methods: {
    async getDashboard() {
      try {
        const { data } = await this.$http.get("/panel/dashboard/user");
        this.dashboard = data;
      } catch (err) {}
    },
    async getCharts() {
      try {
        const { data } = await this.$http.get(
          "/panel/dashboard/user/chart/accounts"
        );
        this.accounts = data;
      } catch (err) {}
    },
    showChangeAccountModal(competitions) {
      this.needChangeAccount = competitions;
      this.visible = true;
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/chart-apex.scss";
</style>
